<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        用传状态管理
      </div>
    </div>
    <div class="common-page common-body">
      <div class="device-cont flex center ">
        <div class="tab1 mt20" id="tab1"></div>
        <div class="tab1 " id="tab2">
          <h2>设备在线状态</h2>
          <p>
            设备数量:<span class="ml10">{{ devicesum }}</span>
          </p>

          <p>
            在线设备:<span class="ml10">{{ onlineNum }}</span>
          </p>
          <p>
            离线设备:<span class="ml10">{{ leaveNum }}</span>
          </p>
        </div>
      </div>

      <div class="common-page common-list">
        <div style=" text-align: end;">
          设备状态选择：
          <el-select v-model="presence" placeholder="请选择设备状态" size="small">
            <el-option :label="'全部'" value=""></el-option>
            <el-option :label="'在线'" value="true"></el-option>
            <el-option :label="'离线'" value="false"></el-option>
          </el-select>
        </div>

        <el-table :data="presencedData" class="" :default-sort="{ prop: 'outline_time', order: 'descending' }">
          <el-table-column prop="c_name" label="单位名称" align="center" width="300"> </el-table-column>
          <el-table-column prop="ct_transmission_num" label="设备编号" align="center"> </el-table-column>

          <el-table-column prop="online" align="center" label="是否在线">
            <template slot-scope="scope">
              <el-button v-if="scope.row.online" size="mini" type="primary" plain>在线</el-button>
              <el-button v-else type="info" plain size="mini">离线</el-button>
            </template>
          </el-table-column>
          <el-table-column sortable prop="outline_time" align="center" label="离线时间" v-if="presence == 'false' || presence == ''"> </el-table-column>

          <el-table-column prop="ct_local" align="center" label="安装位置"> </el-table-column>
          <el-table-column prop="ct_transmission_name" align="center" label="备       注"> </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total"> </el-pagination>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="showDia = false" size="small">取消</el-button>
      </div>
    </el-dialog>
    <el-backtop target=".common-body-style" :title="'返回顶部'"></el-backtop>
  </div>
</template>

<script>
import echarts from 'echarts';
export default {
  data() {
    return {
      list: [],
      params: { page: 1 },
      total: 0,
      showDia: false,
      searchForm: this.$getForm('unitSearch'),
      editData: {},
      onlineNum: 0,
      leaveNum: 0,
      devicesum: 0,
      remoteFuncs: {},
      presence: '',
    };
  },
  created() {
    this.getList();
  },
  computed: {
    presencedData() {
      // 显示全部数据
      if (this.presence === '') return this.list;
      else return this.list.filter((item) => item.online.toString() === this.presence);
    },
  },
  methods: {
    changeStatus(id, status) {
      switchCompany({ id, status })
        .then((res) => {
          this.getList();
        })
        .catch((err) => {});
    },
    dateFormat() {},
    getList() {
      this.$post('/devicemanage/yongchuan').then((res) => {
        // console.log(res, 'get online num');
        this.list = res.data;
        var arr = [];
        var onlineNum = 0;
        this.list.map((item) => {
          if (item.online) {
            onlineNum++;
          }
        });
        arr.push({
          value: this.list.length - onlineNum,
          name: '离线设备',
        });
        arr.push({
          value: onlineNum,
          name: '在线设备',
        });
        this.devicesum = this.list.length;
        this.onlineNum = onlineNum;
        this.leaveNum = this.list.length - onlineNum;
        this.makeChart(arr);
      });
    },
    // chartT
    makeChart(arr) {
      // if (arr.length == 0) {
      //   arr.push({ value: 0, name: "暂无数据" });
      // }
      // console.log(arr);
      let option = {
        label: {
          normal: {
            show: true,
          },
        },
        title: {
          left: 'center',
          top: '0px',
          textStyle: {
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          top: '30px',
          right: '10px',
          left: '0px',
          data: ['离线', '在线'],
          textStyle: {
            fontStyle: 'normal',
            fontSize: 16,
          },
        },
        series: [
          {
            name: '',
            title: '访问来源',
            type: 'pie',
            radius: '70%',
            center: ['50%', '50%'],

            data: arr,
            color: ['#FFB800', '#00BC8B'],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            label: {
              show: true,
            },
          },
        ],
      };
      echarts.init(document.getElementById('tab1')).setOption(option);
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { page: 1, limit: 10, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.tab1 {
  margin-top: 5px;
  height: 350px;
  width: 40%;
}
#tab2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-left: 1px solid #ccc;
  h2 {
    margin-bottom: 20px;
    font-size: 22px;
  }
  p {
    font-size: 18px;
    margin-top: 10px;
  }
}
</style>
